module.exports = __webpack_public_path__ + "images/company_profile/icon02-c1c363606fce12277268271e879d1802.png";